<div class="container" id="contratolojahouse" #contratolojahouse>

  <button (click)="regresarPagina()" style="width: 100px; height: 40px; padding: 0px; border: 0px;" class="btn btn-outline-info"><i class="fa fa-hand-o-left" style="margin-right: 8px;"></i>Regresar</button>
  <div class="row">
    <div class="col-10 mx-auto ">

        <div class="card" *ngIf="existeContrato" >

          <h4 class="card-title text-center mt-5" id="titulo" #titulo><b>Contrato de Arrendamiento {{contratos.acuerdo==='PENDIENTE'? '(BORRADOR)':''}}</b></h4>
            <div class="card-body">

              <section style=" color: black; margin-bottom: 15px;">
                  Por medio del presente dejamos manifiesta constancia, entre nosotros: Sr(a). <b>{{contratos.usuarioarrendador.nombre +' '+ contratos.usuarioarrendador.apellido}}</b>,
                  con cédula de identidad <b>{{contratos.usuarioarrendador.cedula}}</b>, al que más adelante se
                  lo identificará con el nombre de ARRENDADOR. Y al Sr(a). <b>{{contratos.usuarioarrendatario.nombre+' '+ contratos.usuarioarrendatario.apellido}}</b>,
                  con cédula de identidad <b>{{contratos.usuarioarrendatario.cedula}}</b>, al que más adelante se le identificará
                  con el nombre de ARRENDATARIO. Entre ambos convenimos libremente en celebrar el presente contrato de arrendamiento,
                  bajo el tenor de las siguientes cláusulas:
              </section>


              <section style=" color: black; margin-bottom: 15px;">
                <b>PRIMERA.-</b> El arrendador da en arrendamiento al arrendatario un(a) <b>{{contratos.inmueble.tipo}}</b> ubicado(a)
                  en <b>{{contratos.inmueble.direccion}}</b> y que consta de los servicios de: <b>{{contratos.inmueble.servicio}}.</b>
              </section>


              <section style=" color: black; margin-bottom: 15px;">
                <b>SEGUNDA.-</b> El arrendatario se compromete a mantener en perfectas condiciones el local arrendado y lo destinará única y
                  exclusivamente para el uso de <b>VIVIENDA</b> sin poder darle otro uso, salvo convenio posterior con el arrendador/a.
              </section>

              <section style=" color: black; margin-bottom: 15px;">
                <b>TERCERA.-</b> El canon de arrendamiento será de <b>${{contratos.monto}}</b> dólares, valor que será cancelado de forma
                  mensual, pagaderos y por mesadas anticipadas entre los tres primeros días del  inicio de cada mes,
                  el mismo que dará inicio desde <b>{{contratos.fechainicio |date:'dd-MM-yyyy'}}</b> hasta el
                  <b>{{contratos.fechafin |date:'dd-MM-yyyy'}}.</b>
                  En caso de ser renovado el contrato, y de así expresarlo el arrendatario se lo hará previo un reajuste del
                  canon suscrito anteriormente. La renovación comprenderá el período de un año.
                  En este tenor las partes renuncian expresamente el acogerse a un canon distinto del acordado tanto para este contrato,
                  cuanto para su futura renovación. Así el arrendatario renuncia a cualquier reclamo o acción legal, que tenga como
                  fuente este antecedente.
              </section>


              <section style=" color: black; margin-bottom: 15px;">
                <b>CUARTA.-</b> El plazo del presente contrato es <b>de {{contratos.tiempocontrato}} meses</b>, el mismo que termina el
                  <b>{{contratos.fechafin|date:'dd-MM-yyyy'}}</b>, pudiendo ser renovado el mismo de común acuerdo entre las partes en convenio.
              </section>


              <section style=" color: black; margin-bottom: 15px;">
                <b>QUINTA.-</b> Para el término o fin del contrato, las partes deberán comunicar con noventa días de anticipación,
                  conforme lo determina la ley, y en caso de que no se cancelen dos pensiones locativas consecutivas será motivo
                  válido para que el arrendador/a pueda dar por terminado el presente contrato.
              </section>


              <section style=" color: black; margin-bottom: 15px;">
                <b>SEXTA.-</b> El arrendatario declara que recibe en perfectas condiciones el local arrendado para el goce de su uso
                estipulado en la cláusula segunda y comprometiéndose a mantenerlo en buen estado; y, a realizar los arreglos locativos
                pertinentes que el caso lo amerite si existiere leve deterioro. Por otro lado, toda mejora que se desee hacer  en el
                local arrendado se lo realizará previo el consentimiento de la arrendadora.
              </section>

              <section style=" color: black; margin-bottom: 15px;">
                <b>SÉPTIMA.-</b> El pago de los servicios básicos será cancelado por cuenta exclusiva del arrendatario.
              </section>


              <section style=" color: black; margin-bottom: 15px;">
                <b>OCTAVA.-</b> En caso de presentarse alguna controversia de orden legal, las partes renuncian expresamente
                domicilio y fuero, y se someten a los jueces competentes de la Ciudad de {{contratos.inmueble.ciudad}}, provincia
                de {{contratos.inmueble.provincia}}, y, al trámite Verbal Sumario que de darse el caso lo amerite.
              </section>


              <section style=" color: black; margin-bottom: 15px;">
                <b>NOVENA.-</b> Y para dejar constancia entre las  partes y convenidas en mutuo  acuerdo  para su consecuencia final
                de este acto de contrato de todo lo expuesto en su contenido.
                Firman conjuntamente en la Ciudad de {{contratos.inmueble.ciudad}}, provincia de {{contratos.inmueble.provincia}},
                el  {{contratos.fechainicio |date:'dd-MM-yyyy'}}.
              </section>

              <section>

              </section>

              <br>

              <div class="col-12" style=" color: black;" align="right">
                <h6>El acuerdo está <b>{{!contratos.acuerdo? 'PENDIENTE':contratos.acuerdo}}</b> entre las partes</h6>
              </div>
              <br>

              <div class="row m-b-15">
                <div class="col-2">
                  <button (click)="exportarPDF()" class="btn btn-outline-success btn-block"><abbr title="Descargar contrato"><i class="fa fa-download"></i></abbr></button>
                </div>
              <!--  <div class="col-2">
                  <button class="btn btn-outline-primary btn-block" (click)="openPDF()"><abbr title="Abrir contrato"><i class="fa fa-eye"></i></abbr></button>
                </div>-->
              </div>
        </div>
    </div>
  </div>

  </div>
</div>
